import { SectionIconsType } from '@/components/ui/custom/material/slides/sections/view/SectionIcon';
import { DEFAULT_EDITORJS_DATA } from '@/data/hook/editorjs/useEditorJS';
import { OutputData } from '@editorjs/editorjs';
import { t } from 'i18next';
import Chapter from './Chapter';
import { Model, Nullable, Versionable } from './Model';

export type bookType = 'STUDENT' | 'TEACHER';

export enum MaterialType {
  SLIDE = 'SLIDE',
  TEXT = 'TEXT',
  PDF_INTERACTIVE = 'PDF_INTERACTIVE',
}

export default interface Book extends Model, Versionable {
  filename: string;
  uploadedAt: string;
  chapters: Chapter[];
  bookType: bookType;
  materialType: MaterialType;
  file: Nullable<string>;
}

export enum BookUploadStatusEnum {
  PENDING = 'PENDING',
  SUCCEEDED = 'SUCCEEDED',
  FAILED = 'FAILED',
}

export type BookUploadStatus = {
  id: number;
  bookId: number;
  status: BookUploadStatusEnum;
  createdAt: string;
  updatedAt: string;
};

export class Section {
  id: number = 0;
  chapterItemId: number = 0;
  title: string = t('section.title');
  content: OutputData = DEFAULT_EDITORJS_DATA;
  icon: SectionIconsType = 'AcademicCapIcon';
  order: number = 0;
  startsHidden: boolean = false;
  instructions: string | null = null;
  editing?: boolean;
  activitiesIds: number[] = [];

  constructor(init?: Partial<Section>) {
    Object.assign(this, init);
  }
}

export type OptimizedBook = {
  id: number;
  /** @deprecated Use `Book.materialType` instead. */
  bookStyle: BookStyleEnum;
};

/** @deprecated Use {@link MaterialType} instead. */
export enum BookStyleEnum {
  TEXT = 'TEXT',
  APRESENTATION = 'APRESENTATION',
  PDF_INTERACTIVE = 'PDF_INTERACTIVE',
}

export type GeneratedBookStyle = Exclude<
  BookStyleEnum,
  BookStyleEnum.PDF_INTERACTIVE
>;
